// Basic Tandem AI tool set — register AI-callable tools here as Tandem grows (starts empty).

import { TandemAIToolSet } from "../../base/TandemAIToolSet.js";
import { TandemPromptEngineerTool } from "./tandemOrchestrationTools.js";

export class BasicTandemAIToolSet extends TandemAIToolSet {
  registerTools() {
    this.registerTool(TandemPromptEngineerTool);
  }
}
